import React from 'react'
import './style.scss'

export function Checkbox({
  checked = false,
  label = '',
  name,
  onChange,
  classNameCheckBox,
  classNameInput,
  classNameLabel,
}) {
  return (
    <label className={`checkbox-field ${classNameCheckBox || ''}`}>
      <input
        className={`${classNameInput || ''}`}
        onChange={onChange}
        name={name}
        id={name}
        type='checkbox'
        checked={checked}
      />
      {label && <span className={`${classNameLabel || ''}`}>{label}</span>}
    </label>
  )
}
